const { isWalletSigning, onWalletIdle } = require('./walletSigning');

function startAppUpdates({ version, window, document, fetch, checkSession }) {
  let checking = false;
  let updatePending = false;
  let reloading = false;
  let stopped = false;

  const reload = () => {
    if (!stopped && updatePending && !reloading && !isWalletSigning()) {
      reloading = true;
      window.location.reload();
    }
  };

  const check = async () => {
    if (stopped || checking || document.visibilityState === 'hidden') return;
    checking = true;
    const controller = new window.AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 15000);
    try {
      // Session recovery may wait for RPC/network; version checks are independent.
      Promise.resolve().then(checkSession).catch(() => {});
      if (!version) return;
      const response = await fetch('/index.html', { cache: 'no-store', signal: controller.signal });
      if (!response.ok) return;
      const html = new window.DOMParser().parseFromString(await response.text(), 'text/html');
      const latest = html.querySelector('meta[name="a2dao-build"]')?.content;
      if (latest && latest !== version) {
        updatePending = true;
        reload();
      }
    } catch {
      // A failed version request must never cause a reload or clear a session.
    } finally {
      window.clearTimeout(timeout);
      checking = false;
    }
  };

  const unsubscribe = onWalletIdle(reload);
  const timer = window.setInterval(check, 60 * 1000);
  document.addEventListener('visibilitychange', check);
  window.addEventListener('pageshow', check);
  void check();
  return () => {
    stopped = true;
    window.clearInterval(timer);
    document.removeEventListener('visibilitychange', check);
    window.removeEventListener('pageshow', check);
    unsubscribe();
  };
}

module.exports = { startAppUpdates };
